import { take, tap } from 'rxjs/operators';
import { NotificationStoreService } from '../../services/notification.service';
import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { HandsetService } from '../../../core/services/handset.service';
import { NotificationState } from '../../models/notification-state.model';
import { Observable, Subscription } from 'rxjs';
import { AnalyticsEvent, AnalyticsService } from 'src/app/core/services/analytics-service';
import {
  NotificationsContainerRowComponent,
} from '../notifications-container-row/notifications-container-row.component';
import { NotificationStatus } from '../../models/notification.model';
import { AppConfig } from '../../../core/services/app-config.service';
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { CustomerService } from '../../../core/services/customer.service';

@Component({
standalone: false,
  selector: 'app-notifications-container',
  styleUrls: ['./notifications-container.component.scss'],
  templateUrl: './notifications-container.component.html',
  animations: [
    trigger('shake', [
      state('active', style({})),
      transition('* => active', [
        animate(
          '2s ease-in-out'
          , keyframes([
            style({ transform: 'rotate(0deg) scale(1)', offset: 0 }),
            style({ transform: 'rotate(1.5deg) scale(1)', offset: 0.024 }),
            style({ transform: 'rotate(3deg) scale(1.01)', offset: 0.048 }),
            style({ transform: 'rotate(4.5deg) scale(1.02)', offset: 0.072 }),
            style({ transform: 'rotate(6deg) scale(1.03)', offset: 0.096 }),
            style({ transform: 'rotate(7.5deg) scale(1.04)', offset: 0.12 }),
            style({ transform: 'rotate(9deg) scale(1.05)', offset: 0.144 }),
            style({ transform: 'rotate(10.5deg) scale(1.06)', offset: 0.168 }),
            style({ transform: 'rotate(12deg) scale(1.07)', offset: 0.192 }),
            style({ transform: 'rotate(13.5deg) scale(1.08)', offset: 0.216 }),
            style({ transform: 'rotate(15deg) scale(1.09)', offset: 0.24 }),
            style({ transform: 'rotate(13.5deg) scale(1.1)', offset: 0.264 }),
            style({ transform: 'rotate(12deg) scale(1.09)', offset: 0.288 }),
            style({ transform: 'rotate(10.5deg) scale(1.08)', offset: 0.312 }),
            style({ transform: 'rotate(9deg) scale(1.07)', offset: 0.336 }),
            style({ transform: 'rotate(7.5deg) scale(1.06)', offset: 0.36 }),
            style({ transform: 'rotate(6deg) scale(1.05)', offset: 0.384 }),
            style({ transform: 'rotate(4.5deg) scale(1.04)', offset: 0.408 }),
            style({ transform: 'rotate(3deg) scale(1.03)', offset: 0.432 }),
            style({ transform: 'rotate(1.5deg) scale(1.02)', offset: 0.456 }),
            style({ transform: 'rotate(0deg) scale(1.01)', offset: 0.48 }),
            style({ transform: 'rotate(-1.5deg) scale(1)', offset: 0.504 }),
            style({ transform: 'rotate(-3deg) scale(1.01)', offset: 0.528 }),
            style({ transform: 'rotate(-4.5deg) scale(1.02)', offset: 0.552 }),
            style({ transform: 'rotate(-6deg) scale(1.03)', offset: 0.576 }),
            style({ transform: 'rotate(-7.5deg) scale(1.04)', offset: 0.6 }),
            style({ transform: 'rotate(-9deg) scale(1.05)', offset: 0.624 }),
            style({ transform: 'rotate(-10.5deg) scale(1.06)', offset: 0.648 }),
            style({ transform: 'rotate(-12deg) scale(1.07)', offset: 0.672 }),
            style({ transform: 'rotate(-13.5deg) scale(1.08)', offset: 0.696 }),
            style({ transform: 'rotate(-15deg) scale(1.09)', offset: 0.72 }),
            style({ transform: 'rotate(-13.5deg) scale(1.1)', offset: 0.744 }),
            style({ transform: 'rotate(-12deg) scale(1.09)', offset: 0.768 }),
            style({ transform: 'rotate(-10.5deg) scale(1.08)', offset: 0.792 }),
            style({ transform: 'rotate(-9deg) scale(1.07)', offset: 0.816 }),
            style({ transform: 'rotate(-7.5deg) scale(1.06)', offset: 0.84 }),
            style({ transform: 'rotate(-6deg) scale(1.05)', offset: 0.864 }),
            style({ transform: 'rotate(-4.5deg) scale(1.04)', offset: 0.888 }),
            style({ transform: 'rotate(-3deg) scale(1.03)', offset: 0.912 }),
            style({ transform: 'rotate(-1.5deg) scale(1.02)', offset: 0.936 }),
            style({ transform: 'rotate(0deg) scale(1.01)', offset: 0.96 }),
            style({ transform: 'rotate(1.5deg) scale(1)', offset: 0.984 }),
            style({ transform: 'rotate(0deg) scale(1)', offset: 1 }),
          ]),
        ),
      ]),
    ]),
  ],
})
export class NotificationsContainerComponent implements OnInit, OnDestroy {
  animationState = '';
  newNotification = false;
  count: number | null;
  countSubscription: Subscription;
  newNotificationSubscription: Subscription;
  animationId = null;

  @ViewChildren(NotificationsContainerRowComponent) allNotifications: QueryList<NotificationsContainerRowComponent>;

  constructor(
    public handsetService: HandsetService,
    public appConfig: AppConfig,
    private notificationService: NotificationStoreService,
    private analyticsService: AnalyticsService,
    private customerService: CustomerService,
  ) {
  }

  public visible = false;
  public notificationState$: Observable<NotificationState>;
  public NotificationStatus = NotificationStatus;

  ngOnInit(): void {
    this.notificationService.init().pipe(take(1)).subscribe();
    this.notificationState$ = this.notificationService.state$;

    this.countSubscription = this.notificationService.count.asObservable().subscribe(value => {
      if (value && value !== null) {
        if (this.count !== null) {
          if (this.count < value) {
            this.startAnimation();
          }
          this.count = value;
        } else {
          this.count = value;
        }
      }
    });
    this.newNotificationSubscription = this.notificationService.newNotifications.asObservable().subscribe(value => {
      if (value) {
        this.startAnimation();
      } else {
        this.stopAnimation();
      }
    });

  }

  ngOnDestroy(): void {
    this.countSubscription.unsubscribe();
    this.newNotificationSubscription.unsubscribe();
    this.stopAnimation();
  }


  public onScrollDown() {
    this.notificationService.loadNextPage().pipe(take(1)).subscribe();
  }

  public onClick() {
    if (!this.appConfig.config.applicationReadOnlyMode) {
      this.visible = !this.visible;
      this.visible && this.analyticsService.trackEvent(new AnalyticsEvent('Notification menu opened'));
      this.customerService.saveOpenNotificationDate()
        .pipe(
          tap(() => this.notificationService.newNotifications.next(false)),
        ).subscribe();
    }
  }

  public setAllNotificationsToRead = () => this.setAllToStatus(NotificationStatus.READ);
  public setAllNotificationsToUnread = () => this.setAllToStatus(NotificationStatus.UNREAD);

  private setAllToStatus = (status: NotificationStatus) =>
    this.notificationService
      .changeAllReadStatus(status)
      .pipe(
        tap(() => this.allNotifications.map((singleNotification) => (singleNotification.notification.status = status))),
      );

  startAnimation() {
    this.stopAnimation();
    this.newNotification = true;
    this.animationId = setTimeout(() => {
      this.animationState = 'active';
    }, 0);

  }

  stopAnimation() {
    this.newNotification = false;
    if (this.animationId) {
      clearInterval(this.animationId);
    }
    this.animationState = '';

  }
}
